import { SegmentFragment } from 'generated/graphql';
import segmentResolver from './segment';

export default function legResolver(leg: {
  segments: SegmentFragment[];
  segmentKeys: number[];
}) {
  return {
    ...leg,
    segments: leg.segments.map(segmentResolver),
  };
}
